import { defineComponent } from 'vue';
import __vue_component__ from '../../../../../cards/BasicCard/BasicCard.vue.js';
import __vue_component__$8 from '../../../../../inputs/FilePicker/FilePicker.vue.js';
import __vue_component__$1 from '../../ItineraryList/components/ExpandCopyID.vue.js';
import __vue_component__$3 from '../../ItineraryList/components/ItineraryRelatedStatusView.vue.js';
import { useWaypointActionContext } from './waypointActionContext.js';
import __vue_component__$5 from './WaypointProcedureCard/WaypointProcedureCard.vue.js';
import __vue_component__$2 from '../../../../../ui/InteractivePopup/InteractivePopup.vue.js';
import __vue_component__$4 from '../../../../../ui/Skeleton.vue.js';
import __vue_component__$6 from '../../../../../ui/Tag/Tag.vue.js';
import __vue_component__$7 from '../../../../../ui/Tooltip/Tooltip.vue.js';

var script = defineComponent({
    name: 'ItineraryNonMailInWaypointActionCard',
    components: {
        BasicCard: __vue_component__,
        ExpandCopyID: __vue_component__$1,
        InteractivePopup: __vue_component__$2,
        ItineraryRelatedStatusView: __vue_component__$3,
        Skeleton: __vue_component__$4,
        WaypointProcedureCard: __vue_component__$5,
        Tag: __vue_component__$6,
        Tooltip: __vue_component__$7,
        FilePicker: __vue_component__$8,
    },
    props: {
        inputDisabled: Boolean,
        waypointAction: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        return useWaypointActionContext({ waypointActionID: props.waypointAction.id });
    },
});

export { script as default };
